// import { gsap } from 'gsap';

export default class Header {
  constructor() {
    this.headerEl = document.getElementById('wrapper-navbar');
    this.isWorking = false;
    this.isMenuWorking = false;
    this.logo = this.headerEl.querySelector('.main-header .logo');
	this.altLogo = this.headerEl.querySelector('.ar-svg .logo-alt');

    this.body = document.body;
    this.debounce_timer = null;

    this.events();
  }

  onStickyHeaderShow() {
    this.isMenuWorking = true;
    // window.containerSticky.addClass('active');
    // this.headerEl.classList.add('is-sticky');
    this.body.classList.add('has-sticky-header');

	  // gsap.to(this.logo, { duration: 0.4, y: '-10%', ease: 'power4.in', onComplete: () => {
			this.isMenuWorking = false;
		  // }});
  }

  onStickyHeaderHide() {
    this.isMenuWorking = true;
    this.body.classList.remove('has-sticky-header');
    this.isMenuWorking = false;
  }

  onScroll() {
      if(this.debounce_timer) {
        window.clearTimeout(this.debounce_timer);
      }

      this.debounce_timer = window.setTimeout(() => {
        if (document.body.classList.contains('main-menu-open')) return;

        if ( this.isMenuWorking ) return;

        let pageYOffset = window.pageYOffset || document.body.scrollTop;

        if (100 < pageYOffset) {
          this.onStickyHeaderShow();
        } else {
          this.onStickyHeaderHide();
        }
      }, 50);
  }

  onWindowResize(ev) {

  }

  onMainMenuOpen(ev) {
    this.onStickyHeaderShow.bind(this)();
  }

  onMainMenuClose(ev) {
    window.dispatchEvent(new Event('scroll'));
  }

  events() {
    window.addEventListener('scroll', this.onScroll.bind(this), false);
    window.addEventListener('resize', this.onWindowResize.bind(this), false);

    window.addEventListener('burgerButton.open', this.onMainMenuOpen.bind(this), false);
		window.addEventListener('burgerButton.close', this.onMainMenuClose.bind(this), false);
  }
}
